import 'Agent/Policies/components/PolicyImagesCard.sass';
import {PolicyImage} from 'Agent/Policies/sagas/policySaga';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {Table, TableCell, TableRow, TableBody} from '@material-ui/core';
import AllstateCard from 'Shared/components/AllstateCard';
import FileDownloadButton, {FileExtension} from 'Shared/components/FileDownloadButton';
import {renderAsyncView} from 'Shared/components/RenderAsync';
import {WithSelectedAgencyProps} from 'Shared/components/withSelectedAgency';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {AgentAgencyClaim} from 'Users/models/AgentAgencyClaim';
import {Grid} from '@material-ui/core';

const NoResultsAvailableMessage = () => <div className="policy-images__no-results-available">No Results Available</div>;

type ImagesTableProps = {images: PolicyImage[]};
const ImagesTable = ({images, selectedAgency}: ImagesTableProps & WithSelectedAgencyProps) => (
  <Table className="policy-images__table">
    <TableBody>
      <TableRow>
        <TableCell>File Name</TableCell>
        <TableCell>Date Created</TableCell>
        <TableCell></TableCell>
      </TableRow>
      {images &&
        images.length > 0 &&
        images.map(image => (
          <TableRow key={`policy-image-row_${image.description}`}>
            <TableCell>{image.description}</TableCell>
            <TableCell>{toFormattedDateAsUTC(image.createDate)}</TableCell>
            <TableCell>
              <Grid container>
                <Grid item>
                  <FileDownloadButton
                    downloadedFileName={image.description!}
                    extension={FileExtension.PDF}
                    displayTooltip={false}
                    relativeFileLocation={
                      image.links![0]!.href! +
                      addFilterParameters({encryptedIdentifier: selectedAgency.encryptedIdentifier})
                    }
                  >
                    Download File
                  </FileDownloadButton>
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
        ))}
    </TableBody>
  </Table>
);

const PolicyImagesCard = (props: {selectedAgency: AgentAgencyClaim}) => {
  const {policyImages} = useSelector((state: ReducerState) => state.policy);

  return (
    <AllstateCard title="Policy Images">
      <div className="policy-images__container">
        {renderAsyncView(policyImages, imagesPayload =>
          imagesPayload.images && imagesPayload.images.length > 0 ? (
            <ImagesTable images={imagesPayload.images} selectedAgency={props.selectedAgency} />
          ) : (
            <NoResultsAvailableMessage />
          )
        )}
      </div>
    </AllstateCard>
  );
};

export default PolicyImagesCard;
